import {
    TeaserEntry,
  } from "../helper/interfaces";
  import React from "react";
  
  import { AdInformationInterface } from "../helper/PageInformationInterface";
  import { useLoggedRouter } from "../helper/useLoggedRouter";
  import { AppTheme } from '../helper/enums'
import TeaserAdMarker from "./teaserAdMarker";
import { getLinkObjectFromTeaser } from "../helper/link";
  
  function formatDateOrTime(input: string): string {
    const inputDate = new Date(input);
    const currentDate = new Date();

    inputDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === currentDate.getTime()) {
      return new Date(input).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) + " Uhr";
    } else {
      return inputDate.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }
  }
  
  export interface TeaserData {
    teaser: TeaserEntry;
    className?: string;
    navigate?: (articleId: string, ressortId: string) => void;
    adInformation?: AdInformationInterface;
    ignoreLead?: boolean;
  }
  
  function TeaserTickerView(data: TeaserData) {
    const [routerPush] = useLoggedRouter();
    const internalNavigate = async (e, articleId?: string, ressortId?: string) => {
      e.stopPropagation();
      e.preventDefault();
  
      if (data.navigate) {
        data.navigate(articleId ?? '', ressortId ?? '');
      } else if(articleId) {
        await routerPush(`/article/${encodeURIComponent(articleId)}`);
      } else if(ressortId) {
        await routerPush(`/ressort/${encodeURIComponent(ressortId)}`);
      } else {
        await routerPush(`/article/${encodeURIComponent(data.teaser.id)}`);
      }
    };
  
    const teaser = data.teaser;
  
    const teaserClassName = `teaser teaser-ticker ticker-view-teaser teaser--type-${
      teaser.type
    }`;
  
    function renderContent() {
      return (
        <div className="flex items-stretch ticker-view grid grid-cols-3 sm:grid-cols-5 gap-1">
          { process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nb &&
            <>
              {teaser.subline &&
                <div className="article-date">
                  {teaser.subline}
                </div>
              }
              {!teaser.subline &&
                <div className="article-date">
                  <div className="article-point"></div>
                </div>
              }
            </>
          }
        
          <div className="teaser-body flex-1 col-span-2 sm:col-span-4">

            { process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nb &&
              <>
              {(teaser.paid || teaser.topline || teaser.adIdentifier) && (
                  <div className="teaser-info">
                    <TeaserAdMarker adIdentifier={teaser.adIdentifier} />
                    {teaser.paid && !teaser.hidePlusIcon && <div className="icon-nnplus" aria-label="NN+"></div>}
                    {(teaser.topline) && (
                      <div className="teaser-topline">
                        <div>{teaser.topline}</div>
                      </div>
                    )}
                  </div>
                )}
              </>
            }
  
            { process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn &&
              <div>
                <TeaserAdMarker adIdentifier={teaser.adIdentifier} />
                { teaser.subline && 
                  <div className="teaser-info">
                    <div className="teaser-time">
                      {teaser.subline}
                    </div>
                  </div>
                }
                { teaser.paid && !teaser.hidePlusIcon &&
                  <div className="teaser-info">
                    <div className="icon-nnplus" aria-label="NN+"></div>
                  </div>
                }
                { teaser.topline && 
                  <div className="teaser-info teaser-topline">
                    <div>{teaser.topline}</div>
                  </div>
                }
              </div>
            }
            {teaser.title && <h3 className="teaser-title">{teaser.title}</h3>}
          </div>
        </div>
      );
    }
    const linkObject = getLinkObjectFromTeaser(teaser);
  
    return (
      <>
        {linkObject && linkObject.internalLink && !linkObject.externalLink && (
          <a
            href={linkObject.internalLink}
            key={`teaser-link-${teaser.id}`}
            onClick={(e) => {
              internalNavigate(e, linkObject.articleId ?? '', linkObject.ressortId ?? '');
            }}
            data-name={`article-${teaser.id}`}
            className={teaserClassName}
          >
            {renderContent()}
          </a>
        )}
        {linkObject && linkObject.externalLink && (
          <a
            href={linkObject.externalLink}
            target="_blank"
            rel="noreferrer"
            key={`teaser-link-${teaser.id}`}
            data-name={`article-${teaser.id}`}
            className={teaserClassName}
          >
            {renderContent()}
          </a>
        )}
      </>
    );
  }
  
  export default TeaserTickerView;
  